import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { GoalsPageContainer } from './GoalsPageContainer';
import { actions } from './GoalsPageContainer.actions';
import { I18nContext } from 'utils/I18n/context';

const GoalsPageContainerComponent = connect(
    function mapStateToProps() {
        return {};
    },
    function mapDispatchToProps() {
        return { onUpdate: actions.update };
    }
)(GoalsPageContainer);

export default function GoalsPageContainerWrapper(props) {
    const { t } = useContext(I18nContext);
    
    return (
        <GoalsPageContainerComponent
            {...props}
            t={t}
        />
    );
}
